import React from 'react'

import { ReactComponent as HeaderTelegram } from '../assets/svg/Header/HeaderTelegram.svg'
import { ReactComponent as HeaderWhatsApp } from '../assets/svg/Header/HeaderWhatsApp.svg'
import { ReactComponent as HeaderHolded } from '../assets/svg/Header/HeaderHolded.svg'
import { ReactComponent as HeaderMonday } from '../assets/svg/Header/HeaderMonday.svg'
import { ReactComponent as HeaderSAP } from '../assets/svg/Header/HeaderSAP.svg'
import { ReactComponent as HeaderGoogle } from '../assets/svg/Header/HeaderGoogle.svg'
import { ReactComponent as DevIcon } from '../assets/svg/Header/IntegrationDev.svg'
import { ReactComponent as CristmasThree } from '../assets/svg/Header/cristmasthree.svg'
import { ReactComponent as Darts } from '../assets/svg/Header/darts.svg'
import HeaderMakro from '../assets/png/Header/HeaderMakro.jpg'
import HeaderMercadona from '../assets/png/Header/HeaderMercadona.jpg'
import HeaderConsentio from '../assets/png/Header/HeaderConsentio.jpg'
import HeaderAmazon from '../assets/png/Header/HeaderAmazon.jpg'

export const integrations = [
  {
    link: 'Telegram',
    name: 'Telegram',
    icon: <HeaderTelegram width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: true,
  },
  {
    link: 'WhatsApp',
    name: 'WhatsApp',
    icon: <HeaderWhatsApp width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: true,
  },
  {
    link: 'Holded',
    name: 'Holded',
    icon: <HeaderHolded width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: true,
  },
  {
    link: 'Monday',
    name: 'Monday',
    icon: <HeaderMonday width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: true,
  },
  {
    link: 'SAP',
    name: 'SAP',
    icon: <HeaderSAP width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: true,
  },
  {
    link: 'Google',
    name: 'Google',
    icon: <HeaderGoogle width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: true,
  },
  {
    link: 'Makro',
    name: 'Makro',
    icon: (
      <img
        src={HeaderMakro}
        width={'30px'}
        height={'30px'}
      />
    ),
    enabled: true,
    disabled: true,
  },
  {
    link: 'Mercadona',
    name: 'Mercadona',
    icon: (
      <img
        src={HeaderMercadona}
        width={'30px'}
        height={'30px'}
      />
    ),
    enabled: true,
    disabled: true,
  },
  {
    link: 'Consentio',
    name: 'Consentio',
    icon: (
      <img
        src={HeaderConsentio}
        width={'30px'}
        height={'30px'}
      />
    ),
    enabled: true,
    disabled: true,
  },
  {
    link: 'Amazon',
    name: 'Amazon',
    icon: (
      <img
        src={HeaderAmazon}
        width={'30px'}
        height={'30px'}
      />
    ),
    enabled: true,
    disabled: true,
  },
  {
    link: 'https://tpoappdev-55c3c.ondigitalocean.app/admin/orders',
    name: 'Dev Mode',
    icon: <DevIcon width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
    permission: true,
  },
  {
    link: '/admin/year?year=2025',
    name: 'Results 2025',
    icon: <CristmasThree width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
    permission: true,
  },
  {
    link: '/admin/year?year=2026',
    name: 'Results 2026',
    icon: <Darts width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
    permission: true,
  }
]
